export default __webpack_public_path__ + "static/media/link3.3dbe787d.png";